import { z } from 'zod'

import { listQueryZodFields } from './system'

export const adminSalesAggregateQuerySchema = z.object({
  ...listQueryZodFields,
  dateStart: z.coerce.date(),
  dateEnd: z.coerce.date(),
})

export const adminSalesAggregateDataSchema = z.object({
  ticketSales: z.number(),
  reservationSales: z.number(),
  ticketsCount: z.number().int().nonnegative(),
  reservationsCount: z.number().int().nonnegative(),
})

export const adminSalesAggregateResponseSchema = z.object({
  data: adminSalesAggregateDataSchema,
})
